<template>
    <div class="bg">
        <div class="container">
            <h1>PERK - Обратная связь по новым блюдам</h1>
            <v-alert
                v-if="popup === true"
                :color="classPopUp"
                :icon="'$' + classPopUp"
                :text="textPopUp"
            ></v-alert>
            <form @submit.prevent="formSubmit" v-if="popup !== true">
                <label for="selectedDish">Выберете блюдо</label>
                <v-select
                    clearable
                    id="selectedDish"
                    v-model="selectDish"
                    :items="dishes"
                    variant="outlined"
                    :rounded="'rounded-pill'"   
                ></v-select>
                <label for="selectedGrade">Какую оценку нашему блюду дал гость?</label>
                <v-slider
                        id="selectedGrade"
                        color="#41464b"
                        track-color="#b2b2b2"
                        :step="0.1"
                        :min="0"
                        :max="0.5"
                        thumb-label="always"
                        v-model="grade"
                    >
                        <template v-slot:thumb-label="{ modelValue }">
                            {{ modelValue * 10 }}
                        </template>
                </v-slider>
                <label for="selectedGrade">Комментарий к оценке (кислое послевкусие, слишком сладкий, cyxoe мясо и пр...)</label>
                <v-textarea
                    id="selectedCommentDish"
                    variant="outlined"
                    v-model="comment"
                    rounded="rounded-xl"       
                ></v-textarea>
                <v-btn 
                    variant="tonal"
                    type="submit"
                    size="large"
                    :disabled="this.formState === 'send' ? true : comment === '' ? true : false"
                    class="btn"
                >
                    Отправить
                </v-btn>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            formState: 'wait',
            selectDish: "Cкрэмбл с томатным конкассе",
            dishes: [
                "Cкрэмбл с томатным конкассе",
                "Cпринг-ролл"
            ],
            grade: 0.3,
            comment: '',
            popup: false,
            textPopUp: '',
            classPopUp: ''
        }
    },
    methods: {
        async formSubmit() {
            this.formState = 'send'

            const URI_API = `https://api.telegram.org/bot${process.env.VUE_APP_TOKEN}/sendMessage`

            let now = new Date();

            let message = `<b>Новая заявка!</b>\n`;
            message += `Позиция меню: <b>${this.selectDish}</b>\n`;
            message += `Оценка позиции: <b>${this.grade * 10}</b>\n`;
            message += `Комментарий: <b>${this.comment}</b>\n`;
            message += `\n`;
            message += `Заведение: <b>PERK</b>\n`
            message += `Дата отправки <b>${now.getDate()}.${now.getMonth() + 1}.${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}</b>\n`;

            await axios.post(URI_API, {
                    chat_id: process.env.VUE_APP_CHAT_PERK_ID,
                    parse_mode: "html",
                    text: message,
            })
            .then((res) => {
                    this.textPopUp = "Ваша заявка успешно отправленна!";
                    this.classPopUp = "success";
                    console.log(res);
            })
            .catch((err) => {
                    this.textPopUp = "Произошла какая-то ошибка! Попробуйте еще раз!";
                    this.classPopUp = "error";
                    console.log(err);
            });

            const formData = new FormData();
            formData.append('date', `${ now.getDate() }-${ now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1 }-${ now.getFullYear() } ${ now.getHours() }:${ now.getMinutes() < 10 ? '0'+ now.getMinutes() : now.getMinutes()}`);
            formData.append('dish', this.selectDish)
            formData.append('grade', this.grade * 10)
            formData.append('comment', this.comment)
            

            await axios.post(process.env.VUE_APP_GSHEETS_PERK, formData)
            .then(result => {
                console.log('Данные успешно отправлены в таблицу:', result);
            })
            .catch(error => {
                console.error('Ошибка при отправке данных в таблицу:', error);
            });
            this.popup = true;

            this.selectDish = "Авокадо тост с яйцом пашот и микс. с"
            this.grade = 0.3
            this.comment = ''
            this.formState = 'wait'
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,900;1,700&display=swap');
.v-btn {
    display: flex;
    border: 0px;
    border-radius: 0px;
    background-color: #c8b9a0;
    font-family: "Roboto";
    font-size: 22px;
    font-weight: 300;
    color: #41464b;
}

.v-btn--disabled {
    background-color: grey;
    color: #41464b;
}

.v-btn.v-btn--density-default {
    height: 60px;
    width: 200px;
}
.btn {
    position: relative;
    margin: 0 auto;
}

.v-slider.v-input {
    margin-top: 30px;
}

#selectedDish[data-v-e50ac4b0] > .v-input__control > .v-field {
    border-radius: 50px !important;
}

h1 {
    font-family: "Roboto";
    font-weight: 700;
    /* text-align: center; */
    text-transform: uppercase;
    font-size: 40px;
}

label {
    font-family: "Roboto";
    font-size: 30px;
    font-weight: 400;
    color: #000;
}
form:deep(.v-field) {
    border-radius: 0px;
}

@media (max-width: 1000px) {
    h1 {
        font-size: 30px;
    }

    label {
        font-size: 20px;
    }

    .v-btn {
        font-size: 16px;
        width: 100%;
    }

    .v-btn.v-btn--density-default {
        height: 40px;
        width: 160px;
    }
}

@media (max-width: 600px) {
    h1 {
        font-size: 24px;
    }

    label {
        font-size: 20px;
    }

    .v-btn {
        width: 100% !important;
    }
}
</style>